(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('ExtraDaysHolidaysDetailController',
        ['$scope', '$q', '$filter', '$uibModalInstance', 'HelperService', 'DateService', 'DayService', 'DayschemeService', 'DayScheme', 'DaySchemeTime', 'Alert', 'labels', 'interval', 'dateEditable', 'userId', 'date', ExtraDaysHolidaysDetailControllerFn]);

    /* controlle for main extra days and holidays */
    function ExtraDaysHolidaysDetailControllerFn($scope, $q, $filter, $uibModalInstance, HelperService, DateService, DayService, DayschemeService, DayScheme, DaySchemeTime, Alert, labels, interval, dateEditable, userId, date) {
        var vm = this;

        // current day from service
        vm.weekday = {};
        // from and to
        vm.from = null;
        // agenda labels
        vm.labels = [];
        // data of service
        vm.data = {};
        // are dates editable
        vm.dateEditable = false;
        // current day to edit
        vm.day = {};
        // is there already an extra day that would be overwritten?
        vm.dateOccupied = false;
        // day loaded ?
        vm.dayLoaded = false;
        vm.previousUpdateFailed = false;

        // service methods
        vm.setAll = DayService.setAll;
        vm.set = DayService.set;
        vm.remove = DayService.remove;
        vm.removeAll = DayService.removeAll;
        vm.removeTime = DayService.removeTime;

        activate();

        // abort 
        vm.abort = function () {
            $uibModalInstance.dismiss('close');
        };

        // save day
        vm.save = function () {
            // block modal
            HelperService.block('#modal');

            // check if new day or existing day
            if (vm.day.id <= 0) {
                // new day -> get the selected date-objects from calendar
                save();
            } //if
            else {
                // update existing day

                if (!vm.previousUpdateFailed) {
                    // add times to current day object
                    vm.day.times = DayService.list();

                    // prepare for save
                    vm.day.prepareForSave(null);
                }

                DayschemeService.update(vm.day.id, vm.day).then(function (result) {
                    Alert.success("Day saved successfully");
                    // back to overview
                    $uibModalInstance.close(result);
                    vm.previousUpdateFailed = false;
                }, function (error) {
                    HelperService.unblock('#modal');
                    vm.previousUpdateFailed = true;
                });

            } //else

        };


        // save days
        function save() {
            // make dayscheme-objects for every selected date (from/to)
            var from = HelperService.date(vm.from);

            // variables to set
            var times = DayService.list();
            var fK_User = userId;

            // make new day object of current date
            var newDay = new DayScheme();
            // set values

            // add times to current day object
            for (var i = 0; i < times.length; i++) {
                // copy time 
                var time = new DaySchemeTime();
                time.extend(times[i]);
                // push
                newDay.times.push(time);
            } // for

            // set date
            newDay.date = HelperService.backendDate(from);
            // set weekday
            newDay.weekday = from.getDay();
            // getDay returns 0 for sunday, but we save it as 7
            if (newDay.weekday === 0) {
                newDay.weekday = 7;
            }
            // set user
            newDay.fK_User = fK_User;
            // description 
            newDay.description = vm.day.description;
            // prepare for save
            newDay.prepareForSave(null);

            // save
            DayschemeService.save(newDay).then(function (values) {
                var results = [];
                for (var i = 0; i < values.length; i++) {
                    results.push(values[i]);
                    if (values[i].hasUserHolidayTimes) {
                        DateService.addExtraDay(values[i]);
                    }
                } //for

                // back to overview
                $uibModalInstance.close(results);
            }, function (error) {
                HelperService.unblock('#modal');
            });
        } // save

        /* activation work */
        function activate() {
            // dates editable ?
            if (dateEditable !== null && typeof dateEditable !== 'undefined') {
                vm.dateEditable = dateEditable ? true : false;
            }

            vm.labels = labels;
            vm.from = date;

            // get/set values
            setDateDependentValues();

            // watch on date update
            var watcher = $scope.$watch(function () { return vm.from; }, function (newVal, oldVal) {
                if (!!newVal && !!oldVal) { 
                    var prevDate = HelperService.date(oldVal);
                    var selectedDate = HelperService.date(newVal);
                    
                    var isSame = moment(prevDate).isSame(selectedDate);                                        
                    if (!isSame) {
                        setDateDependentValues();
                    }
                }
            });

            $scope.$on("$destroy", function () {
                watcher();
                watcher = null;
            });

        } // activate

        // update values that are dependent on the date
        function setDateDependentValues() {

            HelperService.block('#modal');
            vm.dayLoaded = false;

            // set empty to force view update
            vm.weekday = {};

            var deferred = $q.defer();

            var promises = {
                dayscheme: loadDayScheme(),
                holiday: loadHoliday(),
                weekschemeTimes: loadWeekschemeTimes()
            };

            $q.all(promises).then(function (result) {
                var wsTimes = result.weekschemeTimes !== undefined && result.weekschemeTimes !== null ? result.weekschemeTimes.times : [];
                setDynamicData(result.dayscheme, result.holiday, wsTimes);
                // unblock ui
                vm.dayLoaded = true;
                HelperService.unblock('#modal');
                deferred.resolve();
            }, function (error) {
                // unblock ui
                HelperService.unblock('#modal');
                deferred.reject(error);
            });
        }

        /// set/get data of dayscheme
        function setDynamicData(dayscheme, holiday, weekschemeTimes) {
            // current day 
            vm.day = new DayScheme();
            vm.day.extend(dayscheme);
            
            // set holiday object
            vm.day.vmHoliday = holiday;
            
            vm.dateOccupied = false;
            if (vm.dateEditable && vm.day.id > 0 && vm.day.times.length > 0) {
                vm.dateOccupied = true;
            }

            //if (typeof vm.day.vmHoliday !== 'undefined' && vm.day.vmHoliday !== null) {
            //    // it's not possible to overwrite a holiday with a blocking label, so we hide them
            //    vm.labels = $filter('filter')(labels, { isReadOnly: false }, true);
            //} //if
            //else {
            //    // show all labels
            //    vm.labels = labels;
            //} //else

            vm.labels = labels;

            // init service
            DayService.init(vm.day, weekschemeTimes, interval);

            // selected label
            vm.data = DayService.data;
            // select first label as default
            vm.data.label = vm.labels[0];

            // day
            vm.weekday = DayService.day();
        }

        // current dayscheme
        function loadDayScheme() {
            // get dayscheme object for startdate of range
            return DayschemeService.getByDate(userId, vm.from);
        }

        // user holiday 
        function loadHoliday() {
            // is current day a holiday? (other days in range will be overwritten with scheme from startDate, so we only need to check the first date)
            return DayschemeService.holiday(userId, vm.from);
        }

        // user weekscheme times
        function loadWeekschemeTimes() {
            // other days in range will be overwritten with scheme from startDate, so we only need to check the first date
            return DayschemeService.dayschemesOfWeekschemeByWeekday(userId, vm.from);
        }


    }
})();
